
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.009 2.156a4.827 4.827 0 013.337 1.342l.697-.698a.469.469 0 01.8.332V5.75c0 .259-.21.469-.468.469H8.757a.469.469 0 01-.332-.8l.816-.816a3.282 3.282 0 10-.08 4.867.234.234 0 01.32.01l.774.775c.095.095.09.25-.01.34A4.844 4.844 0 012.156 7 4.852 4.852 0 017.01 2.157z","fill":"#fff"}})])
          )
        }
      }
    